<template src="./ConnectZaloComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {onMounted, reactive, ref, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import {AppConstant} from "@/supports/app.constant.ts";
import {useStore} from "@/stores/store.js";
import {useSyncZalo} from "@/stores/syncZalo.js";
import {useAccountStore} from "@/stores/account.js";
import ProgressBarNormal from "@/components/progress-bar/normal/ProgressBarNormal.vue";
import InputPasswordNormal from "@/components/inputs/input-password/normal/InputPasswordNormal.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import ButtonBackComponent from "@/components/buttons/button-back/ButtonBackComponent.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import ButtonNextComponent from "@/components/buttons/button-next/ButtonNextComponent.vue";
import ErrorMessageService from "@/services/error-message.service.ts";
import IconCopy from "@/components/icons/IconCopy.vue";
import router from "@/router/index.ts";
export default {
  name: 'ConnectZaloComponent',
  computed: {
    AppConstant() {
      return AppConstant
    }
  },
  components: {
    IconCopy,
    ButtonNextComponent, ButtonAddComponent, ButtonBackComponent, InputDateTimeNormal, InputPasswordNormal,
    ProgressBarNormal,
    ButtonSearchComponent,
    SelectNormal,
    InputTextNormal,
    BreadcrumbComponent,
    IconHome
  },
  setup() {
    const errors = ref(false);
    const showTooltip = reactive({
      code_challenge: false,
      callback_url: false,
      webhook: false,
    });
    const dataConnectZalo = ref({
      app_id: {
        id: 'app_id',
        label: 'ID ứng dụng',
        placeholder: 'ID ứng dụng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      secret_key: {
        id: 'secret_key',
        label: 'Khoá bảo mật',
        placeholder: 'Khoá bảo mật',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      meta_zalo: {
        id: 'meta_zalo',
        label: 'Tên tệp HTML',
        placeholder: 'Tên tệp HTML',
        value: '',
        error: '',
        isError: false,
        required: true,
      },
      code_challenge: {
        id: 'code_challenge',
        label: 'Mã ủy quyền',
        placeholder: 'Mã ủy quyền',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: true
      },
      callback_url: {
        id: 'callback_url',
        label: 'Callback URL',
        placeholder: 'Callback URL',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: true
      },
      webhook: {
        id: 'webhook',
        label: 'Webhook URL',
        placeholder: 'Webhook URL',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: true
      },
      url_oa_admin: {
        id: 'url_oa_admin',
        label: 'URL OA Admin',
        placeholder: 'URL OA Admin',
        value: '',
        error: '',
        isError: false,
        required: true,
      },
    })
    const stepConnect = ref({
      1: {
        label: 'BƯỚC 1',
        iconText: '1',
        status: 2,
      },
      2: {
        label: 'BƯỚC 2',
        iconText: '2',
        status: 1,
      },
      3: {
        label: 'BƯỚC 3',
        iconText: '3',
        status: 1,
      },
    })
    const labelBtnStepBack = ref('Quay lại')
    const labelBtnStepNext = ref('Tiếp tục')
    const regexMetaZalo = /^https:\/\/([^\/]+)\/zalo_verifier([A-Za-z0-9_]+)\.html$/;
    const regexCallbackZalo = new RegExp(`^${(dataConnectZalo.value.callback_url.value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\?oa_id=[^&]+&code=[^&]+&code_challenge=[^&]+$`);
    const storeCompStore = useStore()
    const accountStore = useAccountStore()
    const syncZaloStore = useSyncZalo()
    const step = ref(1)
    const messError = ref('');
    const errorMessage = ref([]);
    onMounted(() => {
      getConnectZalo()
    });

    watch(() => syncZaloStore.syncZalo, (newSyncZalo) => {
      if(newSyncZalo) {
        dataConnectZalo.value.meta_zalo.value = newSyncZalo.domain_code_auth
        dataConnectZalo.value.app_id.value = newSyncZalo.app_id
        dataConnectZalo.value.code_challenge.value = newSyncZalo.code_challenge
        dataConnectZalo.value.secret_key.value = newSyncZalo.secret_key
        if(dataConnectZalo.value.code_challenge.value) {
          step.value = 2
          stepConnect.value[step.value].status = 2
          for (const stepConnect in step.value) {
            stepConnect.value[stepConnect-1].status = 3
          }
        }
      }
    });

    async function getConnectZalo() {
      const params = {
        company_id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-zalo/sync-zalo-detail'
      await syncZaloStore.getSyncZalo(url, params);
    }
    async function connectZalo() {
      const params = {
        id: accountStore.account.company.id,
        store_id: dataConnectZalo.value.store_id.value
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    function onChange(value, name) {
      dataConnectZalo.value[name].value = value
    }

    function validateForm(value, name) {
      if(name === 'code_challenge') {
        dataConnectZalo.value.code_challenge.isError = false;
        dataConnectZalo.value.code_challenge.error = ''
        errors.value = false
        if(!value) {
          dataConnectZalo.value.code_challenge.isError = true;
          dataConnectZalo.value.code_challenge.error = ErrorText.REQUIRED(dataConnectZalo.value.code_challenge.label);
          errors.value = true
        }
      }
    }

    async function getCodeVerifier() {
      const params = {
        company_id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-zalo/generate-code-challenge';
      await syncZaloStore.getCodeVerifier(url, params);
    }

    function getCallbackURL() {
      dataConnectZalo.value.callback_url.value = AppConstant.BASE_URL + 'callback-zalo/' + accountStore.account.company.company_zip
    }

    function getWebhookURL() {
      dataConnectZalo.value.webhook.value = AppConstant.BASE_URL + 'task/zalo-enqueue/' + accountStore.account.company.company_zip
    }

    function copy(name) {
      if(name) {
        navigator.clipboard.writeText(dataConnectZalo.value[name].value)
        showTooltip[name] = true;
        setTimeout(() => (showTooltip[name] = false), 1500);
      }
    }

    watch(() => syncZaloStore.codeChallenge, (newCodeChallenge) => {
      dataConnectZalo.value.code_challenge.value = newCodeChallenge
    });

    async function authenticateDomainZalo() {
      const match = dataConnectZalo.value.meta_zalo.value.match(regexMetaZalo);
      if(match && match[2]) {
        const params = {
          company_id: accountStore.account.company.id,
          meta_zalo: dataConnectZalo.value.meta_zalo.value
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-zalo/authenticate-domain';
        const res = await syncZaloStore.authenticateDomain(url, params);
        const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
        if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
          errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
        } else {
          await CommonService.showAlertPopup({
            title: res?.message,
            icon: res?.status,
            showConfirmButton: false,
            timer: 1200,
            width: '800px'
          });
        }
      }
    }

    async function storeSettingConnectZalo() {
      const params = {
        m_company_id: accountStore.account.company.id,
        app_id: dataConnectZalo.value.app_id.value,
        secret_key: dataConnectZalo.value.secret_key.value,
        domain_code_auth: dataConnectZalo.value.meta_zalo.value,
        code_verifier: syncZaloStore.codeVerifier,
        callback_url: dataConnectZalo.value.callback_url.value,
        webhook: dataConnectZalo.value.webhook.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-zalo/connect';
      const res = await syncZaloStore.storeSettingConnectZalo(url, params);
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
      } else {
        await CommonService.showAlertPopup({
          title: res?.message,
          icon: res?.status,
          showConfirmButton: false,
          timer: 1200,
          width: '800px'
        });
      }
    }

    async function nextStep() {
      if(step.value === 1) {
        dataConnectZalo.value.app_id.isError = false;
        dataConnectZalo.value.app_id.error = ''
        errors.value = false
        if(!dataConnectZalo.value.app_id.value) {
          dataConnectZalo.value.app_id.isError = true;
          dataConnectZalo.value.app_id.error = ErrorText.REQUIRED(dataConnectZalo.value.app_id.label);
          errors.value = true
        }
        dataConnectZalo.value.secret_key.isError = false;
        dataConnectZalo.value.secret_key.error = ''
        if(!errors.value && !dataConnectZalo.value.secret_key.value) {
          dataConnectZalo.value.secret_key.isError = true;
          dataConnectZalo.value.secret_key.error = ErrorText.REQUIRED(dataConnectZalo.value.secret_key.label);
          errors.value = true
        }
      }
      if(step.value === 2) {
        dataConnectZalo.value.meta_zalo.isError = false;
        dataConnectZalo.value.meta_zalo.error = ''
        errors.value = false
        if(!dataConnectZalo.value.meta_zalo.value) {
          dataConnectZalo.value.meta_zalo.isError = true;
          dataConnectZalo.value.meta_zalo.error = ErrorText.REQUIRED(dataConnectZalo.value.meta_zalo.label);
          errors.value = true
        }
        const match = dataConnectZalo.value.meta_zalo.value.match(regexMetaZalo);
        if(!errors.value && (!match || (match && !match[2]))) {
          dataConnectZalo.value.meta_zalo.isError = true;
          dataConnectZalo.value.meta_zalo.error = ErrorMessageConstant.ERROR_VALIDATE_NAME_HTML_ZALO;
          errors.value = true
        }
        dataConnectZalo.value.code_challenge.isError = false;
        dataConnectZalo.value.code_challenge.error = ''
        errors.value = false
        if(!dataConnectZalo.value.code_challenge.value) {
          dataConnectZalo.value.code_challenge.isError = true;
          dataConnectZalo.value.code_challenge.error = ErrorText.REQUIRED(dataConnectZalo.value.code_challenge.label);
          errors.value = true
        }
        dataConnectZalo.value.callback_url.isError = false;
        dataConnectZalo.value.callback_url.error = ''
        errors.value = false
        if(!dataConnectZalo.value.callback_url.value) {
          dataConnectZalo.value.callback_url.isError = true;
          dataConnectZalo.value.callback_url.error = ErrorText.REQUIRED(dataConnectZalo.value.callback_url.label);
          errors.value = true
        }
        dataConnectZalo.value.webhook.isError = false;
        dataConnectZalo.value.webhook.error = ''
        errors.value = false
        if(!dataConnectZalo.value.webhook.value) {
          dataConnectZalo.value.webhook.isError = true;
          dataConnectZalo.value.webhook.error = ErrorText.REQUIRED(dataConnectZalo.value.webhook.label);
          errors.value = true
        }
      }
      if(step.value === 3) {
        dataConnectZalo.value.url_oa_admin.isError = false;
        dataConnectZalo.value.url_oa_admin.error = ''
        errors.value = false
        if(!dataConnectZalo.value.url_oa_admin.value) {
          dataConnectZalo.value.url_oa_admin.isError = true;
          dataConnectZalo.value.url_oa_admin.error = ErrorText.REQUIRED(dataConnectZalo.value.url_oa_admin.label);
          errors.value = true
        }
        const baseUrl = dataConnectZalo.value.callback_url.value.replace(/\/$/, ''); // bỏ dấu / cuối
        // const escapedBase = baseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        const regexCallbackZalo = new RegExp(
            `^(${dataConnectZalo.value.callback_url.value})\\?oa_id=[^&]+&code=[^&]+&code_challenge=[^&]+$`
        );
        if (!errors.value && !regexCallbackZalo.test(dataConnectZalo.value.url_oa_admin.value)) {
          dataConnectZalo.value.url_oa_admin.isError = true;
          dataConnectZalo.value.url_oa_admin.error = ErrorText.INVALID(dataConnectZalo.value.url_oa_admin.label);
          errors.value = true;
        }
      }
      if(!errors.value) {
        if(step.value === 2) {
          await storeSettingConnectZalo()
        }
        if(errorMessage.value.length > 0) {
          return
        }
        if(step.value === 3) {
          window.location.href = dataConnectZalo.value.url_oa_admin.value
        }
        stepConnect.value[step.value].status = 3
        step.value++;
        stepConnect.value[step.value].status = 2
      }
    }

    function backProcess() {
      stepConnect.value[step.value].status = 1
      step.value--;
      stepConnect.value[step.value].status = 2
    }

    return {
      dataConnectZalo,
      step,
      stepConnect,
      labelBtnStepBack,
      labelBtnStepNext,
      errorMessage,
      onChange,
      showTooltip,
      getCallbackURL,
      getWebhookURL,
      connectZalo,
      validateForm,
      getCodeVerifier,
      authenticateDomainZalo,
      nextStep,
      backProcess,
      copy,
      CommonService,
      errors,
      messError,
    }
  }
}
</script>

<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .copy {
          position: absolute;
          right: 1%;
          top: 55%;
          cursor: pointer;
        }
        .tooltip {
          position: absolute;
          right: 0;
          top: 10%;
          background-color: #111827;
          color: #fff;
          font-size: 12px;
          padding: 4px 8px;
          border-radius: 6px;
          white-space: nowrap;
          opacity: 0.95;
          transform: translateY(0);
        }

        .fade-enter-active,
        .fade-leave-active {
          transition: opacity 0.3s, transform 0.3s;
        }
        .fade-enter-from,
        .fade-leave-to {
          opacity: 0;
          transform: translateY(-5px);
        }
      }
    }
  }
}
</style>